import React from 'react';
import { Button} from 'antd-mobile';
import defaultImg from './default.png'

class carMaintenance extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
        };
    }

    render() {
        
        return (
            <div className="carMaintenanceBox" style={{minHeight: '100vh', background: '#f3f4f5'}}>
                <img src={defaultImg} style={{width: '100%'}}/>
            </div>
        );
    }
}
export default carMaintenance;


// WEBPACK FOOTER //
// ./src/carMaintenance/index/index.js